export enum TabCotacao {
  SolicitacaoCotacao = 0,
  CotacaoFutura = 1,
  SolicitacaoEndosso = 2
}
